import styled, { css } from 'styled-components/macro'
import { gradients } from 'theme/colors'

export type DividerDirection = 'horizontal' | 'vertical'

const DividerWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`

export const DividerBlur = styled.div<{ direction: DividerDirection }>`
  position: absolute;
  z-index: 2;
  ${({ direction }) =>
    direction === 'horizontal'
      ? css`
          top: 50%;
          right: 0;
          width: 148px;
          height: 6px;
          transform: translateY(-50%);
        `
      : css`
          top: 50%;
          left: -2px;
          width: 6px;
          height: 148px;
          transform: translateY(-50%);
        `};
  background: ${({ direction }) =>
    direction === 'horizontal' ? gradients.gradientDividerBlurPrimary : gradients.gradientDividerBlurSecondary};
  filter: blur(3px);
`

export const DividerStyled = styled.div<{ direction: DividerDirection }>`
  z-index: 1;
  ${({ direction }) =>
    direction === 'horizontal'
      ? css`
          width: 100%;
          height: 1px;
        `
      : css`
          width: 1px;
          height: 100%;
        `};
  background: ${({ direction }) =>
    direction === 'horizontal' ? gradients.gradientDividerPrimary : gradients.gradientDividerSecondary};
`

export const Divider = ({ direction }: { direction: DividerDirection }) => (
  <DividerWrapper>
    <DividerStyled direction={direction} />
    <DividerBlur direction={direction} />
  </DividerWrapper>
)
